import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexRequestTypes,
  ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexResponseTypes,
} from "~/domains";

type RequestDataType = {
  params: ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexRequestTypes;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexResponseTypes> => {
  const response =
    await new ApiClient().get<ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexResponseTypes>(
      "/api/members/analysis/employee_condition_submissions_count_calendars",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params: ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexRequestTypes;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndex =
  ({
    params,
    config = {},
  }: PropsType): UseQueryResult<ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndexResponseTypes> => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
      ...config,
      queryKey: [
        "ApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndex",
        params,
      ],
      queryFn: () => request({ params }),
    });
  };
